<template>
  <v-container fluid class="custom-container">
    <v-layout
      class="list-folders-actions"
      justify-center
      v-if="!isEmpty(groupedFolders)"
    >
      <v-flex xs4>
        <span>Exibindo {{ pageStart }} - {{ pageStop }} de {{ foldersCount}}</span>
        <v-btn icon @click="pageNumber--" :disabled="pageNumber <= 1">
          <v-icon>chevron_left</v-icon>
        </v-btn>
        <v-btn icon @click="pageNumber++" :disabled="pageNumber >= pages">
          <v-icon>chevron_right</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <section class="folders">
      <v-layout
        class="folder-list"
        v-for="(group,index) in groupedFolders"
        :key="index"
        column
      >
        <span
          class="subheading grey--text my-3 text-capitalize"
        > {{ index }}</span>

        <div class="elevation-1 group" v-if="group.length > 0">
          <draggable :options="{ delay: dragDelay }">
            <v-layout
              class="item"
              v-for="folder in group"
              :key="folder.id"
              @click.stop="openFolder(folder.id)"
              justify-center
              align-center
              row
              wrap
              @dragstart="startDrag(folder.id)"
              @dragend="setDraggingItem(null)"
              @mousedown="startTimer(folder.id)"
              @mouseup="stopTimer"
              @mouseleave="stopTimer"
              :class="{ 'dragging': folder.id === draggingItemId }"
            >
              <v-flex class="pa-2" xs4>
                <v-layout class="folder-name" align-center row>
                  <img
                    class="d-flex mx-3 folder-icon"
                    src="/static/images/folder/folder-closed-icon.svg"
                    alt="Ícone de Pasta"
                  >
                  <v-layout column>
                    <v-flex class="grey--text">
                      <span class="caption process-number">{{ folder.process_number }}</span>
                    </v-flex>
                    <v-flex class="type-name">
                      <span>{{ folder.folder_type.name }}</span>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-flex>

              <v-flex class="pa-2" xs3 xl4>
                <v-chip color="grey-lighten-2 entity-chip">
                  <v-avatar size="16" color="white">
                    <v-icon size="16" color="grey">mdi-briefcase</v-icon>
                  </v-avatar>
                  <strong class="grey--text text--darken-2 text-truncate">{{ folder.entity.name }}</strong>
                </v-chip>
              </v-flex>

              <v-flex class="pa-2" xs3 xl2>
                <v-list class="user-card pa-0" v-if="folder.current_owner">
                  <v-list-tile avatar>
                    <v-list-tile-avatar color="grey" size="24">
                      <img
                        alt="Avatar"
                        :src="folder.current_owner.avatar.url"
                        v-if="folder.current_owner.avatar.url"
                      >
                      <span class="caption" v-else>{{ acronym(folder.current_owner.name) }}</span>
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title class="body-1">{{ shortName(folder.current_owner.name) }}</v-list-tile-title>
                      <v-list-tile-sub-title
                        class="caption"
                        v-if="folder.current_owner.role"
                      >{{ folder.current_owner.role.name }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>

              <v-flex class="pa-2" xs2 >
                <v-layout align-center>
                  <v-icon v-if="folder.last_transaction" size="22" class="mr-2">mdi-clock-fast</v-icon>
                  <span v-if="folder.last_transaction" class="caption">
                    {{ formatDate(folder.last_transaction.created_at) || 'Sem data de arquivação' }}
                  </span>
                  <span v-else class="caption">
                      Sem data de arquivação
                  </span>
                </v-layout>
              </v-flex>

              <span class="folder-border"></span>
            </v-layout>
          </draggable>
        </div>
      </v-layout>
    </section>
  </v-container>
</template>


<script>
import { capitalize, isEmpty, lowerCase, startCase, truncate } from "lodash";
import acronym from "@/utils/acronym";
import shortName from "@/utils/short-name";
import format from "date-fns/format";
import * as ptLocale from "date-fns/locale/pt";
import draggable from "vuedraggable";

export default {
  name: "archived",
  components: {
    draggable
  },
  mounted() {
    this.getFolders();
  },
  data() {
    return {
      firstRender: true,
      truncate,
      shortName,
      isEmpty,
      pageNumber: 1,
      rowsPerPage: 20,
      draggingItemId: null,
      timer: null,
      dragDelay: 1500
    };
  },
  methods: {
    startDrag(id) {
      this.$store.commit("setDraggingFolder", id);
    },
    startTimer(id) {
      this.timer = setTimeout(() => {
        this.setDraggingItem(id);
      }, this.dragDelay);
    },
    stopTimer() {
      clearTimeout(this.timer);
      this.setDraggingItem(null);
    },
    setDraggingItem(id) {
      this.draggingItemId = id;
    },
    acronym(string) {
      return acronym(string);
    },
    currentUserIsOwner(currentOwner) {
      return this.user.id === currentOwner.id;
    },
    getFolders() {
      this.$store.dispatch("toggleLoader", { show: true });
      this.$store
        .dispatch("getFoldersArchived", {
          page: this.pageNumber,
          limit: this.rowsPerPage,
          searchText: this.searchText || ""
        })
        .finally(() => {
          this.$store.dispatch("toggleLoader", { show: false });
        });
      this.$store.dispatch("getFoldersCount");
    },
    openFolder(id) {
      const route = this.$router.resolve(`/pastas/${id}/show`);
      window.open(route.href, "_blank");
    },
    capitalizeText(string) {
      return capitalize(lowerCase(string));
    },
    startCaseText(string) {
      return startCase(lowerCase(string));
    },
    formatDate(date) {
      return format(date, "DD/MM/YYYY");
    },
    formatMonthYear(date) {
      return format(date, "MMMM [de] YYYY", { locale: ptLocale });
    },
    resetFolders() {
      this.pageNumber = 1;
      this.$store.dispatch("getFoldersArchive");
    },
    orderDateToString(folder) {
      return folder.last_transaction == null
        ? "Sem data"
        : this.formatMonthYear(folder.last_transaction.created_at);
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    loading() {
      return this.$store.getters.loading;
    },
    folders() {
      return this.$store.getters.folders;
    },
    foldersArchived() {
      if (this.$store.getters.folders.length === undefined) {
        return [];
      }

      const archiveds = this.$store.getters.folders.filter(
        item => item.folder_section === "archived"
      );
      return archiveds;
    },
    groupedFolders() {
      if (this.foldersArchived === undefined) {
        return [];
      }

      const group = {};
      this.foldersArchived.forEach(folder => {
        if (group[this.orderDateToString(folder)] == null) {
          group[this.orderDateToString(folder)] = [folder];
        } else {
          group[this.orderDateToString(folder)].push(folder);
        }
      });
      return group;
    },
    foldersCount() {
      return this.$store.getters.activeTotalFolders;
    },
    pages() {
      return this.$store.getters.foldersPagesCount;
    },
    pageStart() {
      return this.pageNumber * this.rowsPerPage - (this.rowsPerPage - 1);
    },
    pageStop() {
      return Math.min(
        this.pageStart + (this.rowsPerPage - 1),
        this.foldersCount
      );
    },
    searchText() {
      return this.$store.getters.searchText;
    }
  },
  watch: {
    pageNumber: {
      handler: "getFolders",
      immediate: true
    },
    searchText(val) {
      if (val === null || val === "" || val.length > 2) {
        this.getFolders();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.folder-list {
  &:last-child {
    margin-bottom: 75px;
  }
}

.custom-container {
  height: calc(100vh - 48px);
  position: relative;
  overflow: hidden;
}

.folders {
  overflow-y: auto;
  height: 100%;
  margin-top: 45px !important;
}

.list-folders-actions {
  position: absolute;
  z-index: 4;
  width: 97%;
  background: white;
  margin-top: 6px;
}

.dragging {
  background-color: #005ece;
}
</style>



// WEBPACK FOOTER //
// src/views/folder/list/archived/Archived.vue